import axios from 'axios'
import {config} from '../config'
export const getwork = () =>{
    return axios.get(config.ourworks)
    .then(function (response) {
        return response
    })
    .catch(function (error) {
      console.log(error);
    })
}

